import React, { Fragment, useState, useEffect } from "react";
import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import trash from "./../../../Assets/Images/trash.png";
import Select from "react-select";
import ReactLoading from "react-loading";
import toast from "react-hot-toast";

//Components
import {
    toastStyle,
    refreshPage,
    isAdmin,
    formatDate,
    TokenExpiry,
    capitalizeFirstLetter,
} from "../../../Helpers/Utils/Common";

//Api
import { getAllBranches } from "../../../Helpers/apiCalls/Purchases/purchaseOrderApi";
import {
    getAllInventoryGroup,
    getInventoryGroup,
    createInventoryGroup,
    updateInventoryGroup,
    deleteInventoryGroup,
    searchBranch,
} from "../../../Helpers/apiCalls/Manage/InventoryGroup";
import Footer from "../../../Components/Footer/Footer";

function FormInventoryLevel({ add, edit }) {

    //*****VARIABLES*****
    const { id, type } = useParams();
    let navigate = useNavigate();
    const [inactive, setInactive] = useState(true);
    const [isClicked, setIsClicked] = useState(false);
    const [branchOptions, setBranchOptions] = useState([]);
    const [addTo, setAddTo] = useState("braddex");
    const [selectedBranches, setSelectedBranches] = useState([
        {
            id: "", name: "",
        },
    ])
    const [addInventoryData, setAddInventoryData] = useState({});


    //*****FUNCTIONS*****
    function renderTable() {
        return (
            <Table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {selectedBranches.map((selectedBranch, index) => {
                        return (
                            <tr>
                                <td >
                                    <Select
                                        className="react-select-container"
                                        placeholder="Select Branch..."
                                        value={selectedBranch.entry}
                                        options={branchOptions}
                                        onChange={(e) => handleAddNameChange(e, index)}
                                    />
                                </td>
                                <td>
                                    <div className="align-middle">
                                        <img
                                            src={trash}
                                            alt="delete"
                                            onClick={() =>
                                                handleRemoveBranch(index)
                                            }
                                            className="cursor-pointer"
                                        />
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        );
    }

    const handleAddNameChange = (e, id) => {
        const { name, value, label } = e;
        if (e.name === "branch_id") {
            var newBranchList = selectedBranches;
            var newEntries = newBranchList.map((branch, index) => {
                if (index === id) {
                    var info = {
                        name: name,
                        label: label,
                        value: value,
                    };
                    branch.entry = info;
                    branch.name = name;
                    branch.label = label;
                    branch.value = value;
                }
                return branch;
            });
            setSelectedBranches(newEntries);
        }
    };

    function handleRemoveBranch(id) {
        const rowId = id;
        const newItemList = [...selectedBranches];
        newItemList.splice(rowId, 1);
        setSelectedBranches(newItemList);
    }

    function handleAddBranch() {
        const newItem = {
            id: "",
            name: ""
        };
        setSelectedBranches((prevItems) => [...prevItems, newItem]);
    }

    const handleAddChange = (e) => {
        const { name, value } = e.target;
        setAddInventoryData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        if(add) {
            createInventory()
        } else if(edit) {
            updateInventory()
        }
    };

    //*****API CALLS*****
    async function fetchBranches() {

        const response = await searchBranch();
        if(response.data) {
            var branches = response.data.data.sort((a, b) =>
                a.name > b.name ? 1 : b.name > a.name ? -1 : 0
            );

            var cleanedArray = branches.map((branch) => {
                var info = {};

                info.name = "branch_id";
                info.label = `${branch.name}`;
                info.value = `${branch.id}`;

                return info;
            });
            setBranchOptions(cleanedArray);
        }
        
    }

    async function createInventory() {
        setIsClicked(true);
        const response = await createInventoryGroup(addInventoryData, selectedBranches);
        if (response.data) {
            toast.success(response.data.message, {
                style: toastStyle(),
            });
            navigate(-1);
        } else {
            response.error?.response?.data?.messages.map((data) => {
                return toast.error(data);
            })
            navigate(-1);
        }
        setIsClicked(false);
    }

    async function updateInventory() {
        setIsClicked(true);
        const response = await updateInventoryGroup(addInventoryData, selectedBranches);
        // console.log(response)
        if (response.data) {
            toast.success(response.data.message, {
                style: toastStyle(),
            });
            navigate(-1)
        } else {
            response.error?.response?.data?.messages.map((data) => {
                return toast.error(data);
            })
            navigate(-1)
        }
        setIsClicked(false);
    }

    async function fetchInventory() {
        const response = await getInventoryGroup(id);
        if (response.data) {
            var result = response.data.data;
            var braddexBranches = result.map((branch) => {
                return {
                    type: "braddex",
                    id: branch.id,
                    name: branch.name,
                    details: branch.details,
                    no_of_branches: branch.inventory_group_details.length,
                    inventory_group_details: branch.inventory_group_details,
                };
            });

            var details = braddexBranches[0].inventory_group_details.map((data) => {
                var info = data;
                info.name  = "branch";
                info.label  = data.branch_name;
                info.value  = data.branch_id;
                info.entry = info;
                return info;
            })
            setSelectedBranches(details);

            setAddInventoryData(braddexBranches[0]);
        } else if (response.error) {
            TokenExpiry(response);
        }
    }

    //****** Useeffect *****/
    useEffect(() => {
        fetchBranches();
        if(edit) {
            fetchInventory();
        }
    }, []);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"SUPPLIES"}
                />
            </div>
            <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
            <Row className="mb-4">
                <Col xs={12} lg={7}>
                    <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> Inventory Level </h1>
                </Col>
            </Row>

                <div className="edit-form">
                    
                    <Row className="nc-modal-custom-row mt-0">
                        <Col>
                            NAME
                            <span className="required-icon">*</span>
                            <Form.Control
                                type="text"
                                name="name"
                                defaultValue={addInventoryData?.name}
                                className="nc-modal-custom-input-edit"
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                        </Col>
                    </Row>

                    <Row className="nc-modal-custom-row">
                        <Col>BRANCHES</Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col>
                        <div className="edit-purchased-items">
                            {selectedBranches.length === 0 ? (
                                <span>No Branch Found!</span>
                            ) : (
                                renderTable() 
                            )}
                        </div>
                        </Col>
                    </Row>
                    <Row className="pt-3 PO-add-item">
                        <Col>
                        <Button type="button" onClick={() => handleAddBranch()}>
                            Add Branch
                        </Button>
                        </Col>
                    </Row>
                
                    <div className="d-flex justify-content-end pt-5 pb-3">
                        <button
                            type="button"
                            className="button-secondary me-3"
                            onClick={() => navigate(-1)}
                        >
                            Cancel
                        </button>
                        {isClicked ? (
                            <div className="button-primary me-3 d-flex justify-content-center">
                                <ReactLoading
                                    type="bubbles"
                                    color="#FFFFFF"
                                    height={50}
                                    width={50}
                                />
                            </div>
                        ) : (
                            <button
                                type="button"
                                className="button-primary"
                                onClick={handleSubmit}
                            >
                                Save
                            </button>
                        )}
                    </div>
                </div>
            </div>
            
            
            <Footer/>
        </div>
    );

}


export default FormInventoryLevel;